export default "__VITE_ASSET__BK6hVbd4__"